import type { StackProps } from "@chakra-ui/react";
import { CheckboxGroup } from "@equidefi/ui/forms";
import type { FieldPath, FieldValues } from "react-hook-form";
import { useController, useFormContext } from "react-hook-form";

type CheckboxOption = { label: string; value: string };

export type SmartCheckboxGroupProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<StackProps, "onChange"> & {
  name: TName;
  options: CheckboxOption[];
  size?: "sm" | "md" | "lg";
};

function SmartCheckboxGroup<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({ name, options, ...rest }: SmartCheckboxGroupProps<TFieldValues, TName>) {
  const { control } = useFormContext<TFieldValues>();
  const {
    field,
    fieldState: { error },
  } = useController<TFieldValues, TName>({ name, control });

  return (
    <CheckboxGroup options={options} value={field.value} onChange={field.onChange} error={error?.message} {...rest} />
  );
}

export default SmartCheckboxGroup;
